import { Card, CardContent, CardHeader } from '@deepguide-ai/ui/card'
import { TableSkeleton } from '@deepguide-ai/ui/table-skeleton'
import { Skeleton } from '@deepguide-ai/ui/skeleton'

/** Mirrors org context block in `AuditorDashboardRoutePage`. */
function AuditorDashboardOrganizationSkeleton() {
  return (
    <div className='rounded-sm border border-border bg-card p-4'>
      <div className='flex items-start justify-between gap-4'>
        <div className='min-w-0 flex-1'>
          <Skeleton className='h-[25px] w-48 max-w-full rounded-sm' />
          <div className='mt-1 space-y-1.5'>
            <Skeleton className='h-[19.5px] w-full max-w-2xl rounded-sm' />
            <Skeleton className='h-[19.5px] w-[88%] max-w-xl rounded-sm' />
          </div>
          <div className='mt-2 flex flex-wrap items-center gap-3'>
            <Skeleton className='h-[17px] w-16 rounded-sm' />
            <Skeleton className='h-[17px] w-24 rounded-sm' />
            <Skeleton className='h-[17px] w-14 rounded-sm' />
          </div>
        </div>
        <Skeleton className='h-9 w-[11.5rem] shrink-0 rounded-sm' />
      </div>
    </div>
  )
}

/** Mirrors `InfoCard` in AuditorCyclePages (Card + header row + stat + meta). */
function AuditorDashboardInfoCardSkeleton() {
  return (
    <Card className='h-full rounded-sm border border-border bg-card shadow-none'>
      <CardHeader className='pb-2'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-2'>
            <Skeleton className='h-4 w-4 rounded-sm' />
            <Skeleton className='h-3 w-20 rounded-sm' />
          </div>
          <Skeleton className='h-3.5 w-3.5 rounded-sm' />
        </div>
      </CardHeader>
      <CardContent>
        <Skeleton className='h-7 w-14 rounded-sm' />
        <Skeleton className='mt-1 h-4 w-full max-w-[11rem] rounded-sm' />
      </CardContent>
    </Card>
  )
}

export function AuditorCycleBreadcrumbSkeleton() {
  return (
    <div className='flex min-w-0 items-center gap-1.5'>
      <Skeleton className='h-4 w-12 rounded-sm' />
      <Skeleton className='size-3 shrink-0 rounded-full' />
      <Skeleton className='h-4 w-20 rounded-sm' />
    </div>
  )
}

export function AuditorDashboardSkeleton() {
  return (
    <div className='typo-auditor-dashboard grid gap-6'>
      <AuditorDashboardOrganizationSkeleton />

      <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-4'>
        {Array.from({ length: 4 }, (_, index) => (
          <AuditorDashboardInfoCardSkeleton key={index} />
        ))}
      </div>

      <div>
        <Skeleton className='mb-3 h-5 w-32 rounded-sm' />
        <TableSkeleton
          rows={6}
          columns={5}
          columnWidths={['28%', '18%', '22%', '14%', '18%']}
        />
      </div>
    </div>
  )
}
